"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _styles.makeStyles)(function () {
  return (0, _styles.createStyles)({
    carouselPage: {
      display: 'grid',
      gridTemplateColumns: function gridTemplateColumns(_ref) {
        var cardAmount = _ref.cardAmount;
        return "repeat(".concat(cardAmount, ", 1fr)");
      },
      columnGap: 32
    }
  });
});

var CardCarouselPage = function CardCarouselPage(_ref2) {
  var children = _ref2.children;
  var classes = useStyles({
    cardAmount: _react.default.Children.count(children)
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.carouselPage
  }, children);
};

var _default = CardCarouselPage;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NhcmRDYXJvdXNlbC9DYXJkQ2Fyb3VzZWxQYWdlLnRzeCJdLCJuYW1lcyI6WyJ1c2VTdHlsZXMiLCJjYXJvdXNlbFBhZ2UiLCJkaXNwbGF5IiwiZ3JpZFRlbXBsYXRlQ29sdW1ucyIsImNhcmRBbW91bnQiLCJjb2x1bW5HYXAiLCJDYXJkQ2Fyb3VzZWxQYWdlIiwiY2hpbGRyZW4iLCJjbGFzc2VzIiwiUmVhY3QiLCJDaGlsZHJlbiIsImNvdW50Il0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7Ozs7QUFFQSxJQUFNQSxTQUFTLEdBQUcsd0JBQVc7QUFBQSxTQUMzQiwwQkFBYTtBQUNYQyxJQUFBQSxZQUFZLEVBQUU7QUFDWkMsTUFBQUEsT0FBTyxFQUFFLE1BREc7QUFFWkMsTUFBQUEsbUJBQW1CLEVBQUU7QUFBQSxZQUFHQyxVQUFILFFBQUdBLFVBQUg7QUFBQSxnQ0FBOERBLFVBQTlEO0FBQUEsT0FGVDtBQUdaQyxNQUFBQSxTQUFTLEVBQUU7QUFIQztBQURILEdBQWIsQ0FEMkI7QUFBQSxDQUFYLENBQWxCOztBQVVBLElBQU1DLGdCQUEwQixHQUFHLFNBQTdCQSxnQkFBNkIsUUFBa0I7QUFBQSxNQUFmQyxRQUFlLFNBQWZBLFFBQWU7QUFDbkQsTUFBTUMsT0FBTyxHQUFHUixTQUFTLENBQUM7QUFBRUksSUFBQUEsVUFBVSxFQUFFSyxlQUFNQyxRQUFOLENBQWVDLEtBQWYsQ0FBcUJKLFFBQXJCO0FBQWQsR0FBRCxDQUF6QjtBQUVBLHNCQUFPO0FBQUssSUFBQSxTQUFTLEVBQUVDLE9BQU8sQ0FBQ1A7QUFBeEIsS0FBdUNNLFFBQXZDLENBQVA7QUFDRCxDQUpEOztlQU1lRCxnQiIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBtYWtlU3R5bGVzLCBjcmVhdGVTdHlsZXMgfSBmcm9tICdAbWF0ZXJpYWwtdWkvY29yZS9zdHlsZXMnO1xuXG5jb25zdCB1c2VTdHlsZXMgPSBtYWtlU3R5bGVzKCgpID0+XG4gIGNyZWF0ZVN0eWxlcyh7XG4gICAgY2Fyb3VzZWxQYWdlOiB7XG4gICAgICBkaXNwbGF5OiAnZ3JpZCcsXG4gICAgICBncmlkVGVtcGxhdGVDb2x1bW5zOiAoeyBjYXJkQW1vdW50IH06IHsgY2FyZEFtb3VudDogbnVtYmVyIH0pOiBzdHJpbmcgPT4gYHJlcGVhdCgke2NhcmRBbW91bnR9LCAxZnIpYCxcbiAgICAgIGNvbHVtbkdhcDogMzIsXG4gICAgfSxcbiAgfSksXG4pO1xuXG5jb25zdCBDYXJkQ2Fyb3VzZWxQYWdlOiBSZWFjdC5GQyA9ICh7IGNoaWxkcmVuIH0pID0+IHtcbiAgY29uc3QgY2xhc3NlcyA9IHVzZVN0eWxlcyh7IGNhcmRBbW91bnQ6IFJlYWN0LkNoaWxkcmVuLmNvdW50KGNoaWxkcmVuKSB9KTtcblxuICByZXR1cm4gPGRpdiBjbGFzc05hbWU9e2NsYXNzZXMuY2Fyb3VzZWxQYWdlfT57Y2hpbGRyZW59PC9kaXY+O1xufTtcblxuZXhwb3J0IGRlZmF1bHQgQ2FyZENhcm91c2VsUGFnZTtcbiJdfQ==